(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  if (window.KPWReviews) {
    window.KPWReviews.init(document.getElementById('kpw-product-reviews'));
  }
  // お客様の声（取引レビュー）サマリーテイザー
  (function() {
    var teaser = document.getElementById('kpw-txn-teaser');
    if (!teaser) return;
    var section = document.getElementById('kpw-product-reviews');
    var apiUrl = section ? section.getAttribute('data-api-url') : '';
    if (!apiUrl) return;
    fetch(apiUrl + '/reviews/summary?type=shop')
      .then(function(r) { return r.ok ? r.json() : null; })
      .then(function(data) {
        if (!data || !data.review_count || data.review_count === 0) return;
        var dist = data.rating_distribution || {};
        var good   = parseInt(dist['5'] || 0, 10);
        var normal = parseInt(dist['3'] || 0, 10);
        var bad    = parseInt(dist['1'] || 0, 10);
        var countsEl = document.getElementById('kpw-txn-teaser-counts');
        if (countsEl) {
          var faceG = '<svg viewBox="0 0 40 40" width="18" height="18" aria-hidden="true" style="vertical-align:middle;margin-right:2px"><circle cx="20" cy="20" r="19" fill="#E85555"/><circle cx="13.5" cy="15" r="2.5" fill="#fff"/><circle cx="26.5" cy="15" r="2.5" fill="#fff"/><path d="M13 25 Q20 31 27 25" stroke="#fff" stroke-width="2.5" fill="none" stroke-linecap="round"/></svg>';
          var faceN = '<svg viewBox="0 0 40 40" width="18" height="18" aria-hidden="true" style="vertical-align:middle;margin-right:2px"><circle cx="20" cy="20" r="19" fill="#F5B800"/><circle cx="13.5" cy="15" r="2.5" fill="#fff"/><circle cx="26.5" cy="15" r="2.5" fill="#fff"/><path d="M13 26 L27 26" stroke="#fff" stroke-width="2.5" stroke-linecap="round"/></svg>';
          var faceB = '<svg viewBox="0 0 40 40" width="18" height="18" aria-hidden="true" style="vertical-align:middle;margin-right:2px"><circle cx="20" cy="20" r="19" fill="#4A82E4"/><circle cx="13.5" cy="15" r="2.5" fill="#fff"/><circle cx="26.5" cy="15" r="2.5" fill="#fff"/><path d="M13 28 Q20 22 27 28" stroke="#fff" stroke-width="2.5" fill="none" stroke-linecap="round"/></svg>';
          var parts = [];
          if (good)   parts.push('<span class="kpw-txn-teaser__count">' + faceG + good   + '件</span>');
          if (normal) parts.push('<span class="kpw-txn-teaser__count">' + faceN + normal + '件</span>');
          if (bad)    parts.push('<span class="kpw-txn-teaser__count">' + faceB + bad    + '件</span>');
          countsEl.innerHTML = parts.join('');
        }
        teaser.classList.add('is-visible');
      })
      .catch(function() {});
  })();
});

  } catch(e) { console.error(e); }
})();
})();
